import {
  ComponentFactoryResolver,
  ComponentRef,
  Inject,
  Injectable
} from '@angular/core';
import { ConfirmationDialog } from './confirmation-dialog';
import { ConfirmationComponent } from './confirmation.component';

@Injectable()
export class ConfirmationService {  
  private rootViewContainer: any;
  private factoryResolver: any;
  constructor(@Inject(ComponentFactoryResolver) factoryResolver) {
    this.factoryResolver = factoryResolver;
  }

  setRootViewContainerRef(viewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  private async addDynamicComponent() {
    const factory = this.factoryResolver.resolveComponentFactory(
      ConfirmationComponent
    );
    // const component = factory.create (this.rootViewContainer.parentInjector);
    return this.rootViewContainer.createComponent(factory);
    // const component = factory.create(this.rootViewContainer.parentInjector);
    // const data = this.rootViewContainer.insert(component.hostView);
    // const data = this.rootViewContainer.create;
  }

  confirm(data?: ConfirmationDialog): Promise<boolean | string | number | {}> {
    return new Promise((resolve, reject) => {
      this.addDynamicComponent().then((cmpRef: ComponentRef<any>) => {
        cmpRef.instance.confirm(cmpRef, data).then(res => {
          setTimeout(() => {
            cmpRef.destroy();
          }, 400);
          resolve(res);
        });
      });
    });
  }
}
